import { MantineThemeOverride } from "@mantine/core";
import modalClasses from "../components/ui/app-modal.module.css";

/**
 * Invoice-admin theme override. The look (radius 8/10/14, 14px floor, Button/Input/Badge/Alert,
 * Modal/Drawer overlay and shadow, text ramp) comes from @dehub/theme 2.8.x; the gray palette
 * and table look from styles/base.css. Only the Modal/Drawer chrome classes stay local.
 */
export const invoiceThemeOverride: MantineThemeOverride = {
  components: {
    Modal: {
      classNames: {
        root: modalClasses.modalRoot,
        content: modalClasses.modalContent,
        header: modalClasses.modalHeader,
        title: modalClasses.modalTitle,
        close: modalClasses.modalClose,
        body: modalClasses.modalBody,
      },
    },
    Drawer: {
      defaultProps: {
        position: "right",
        padding: 0,
        radius: 0,
        transitionProps: { transition: "slide-left", duration: 200 },
      },
      classNames: {
        root: modalClasses.drawerRoot,
        content: modalClasses.drawerContent,
        header: modalClasses.drawerHeader,
        title: modalClasses.drawerTitle,
        close: modalClasses.drawerClose,
        body: modalClasses.drawerBody,
      },
    },
  },
};
